export const MarkersPageView = 'markers';
